module.exports = __webpack_public_path__ + "static/media/checkout-startup.a2588a8b.jpg";